import { Points } from '@/domain/points/accounting/model/Points'

export class Balance {
  constructor(
    public readonly points: Points,
    public readonly organizationId: string,
  ) {
  }
}
